var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"Flipped-state-wraper"},[(_vm.loading)?_c('div',{staticClass:"loading-screen"},[_vm._m(0)]):_vm._e(),_c('div',{staticClass:"state-wraper"},[_c('div',{staticClass:"checkpoint-item"},[_c('IndicationsState')],1)])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-border",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])
}]

export { render, staticRenderFns }